import { render, staticRenderFns } from "./CustomerSettings.vue?vue&type=template&id=1a22502e&scoped=true&"
import script from "./CustomerSettings.vue?vue&type=script&lang=js&"
export * from "./CustomerSettings.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSettings.vue?vue&type=style&index=0&id=1a22502e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a22502e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VForm,VRow,VSelect})
